export function isBrowser() {
  return typeof window !== 'undefined' && window?.document != null;
}

export function isServer() {
  return !isBrowser();
}
